import React, { Component } from "react";
import styled from "styled-components";

import { MsgExecuteContract, SyncTxBroadcastResult } from '@terra-money/terra.js';
import {
    createLCDClient,
    CreateTxFailed,
    SignResult,
    Timeout,
    TxFailed,
    TxUnspecifiedError,
    useConnectedWallet,
    UserDenied,
} from '@terra-money/wallet-provider';

const CONTRACT_ADDRESS = 'terra1kur7y05srj5ktellf0cyhqem6w48m3puwfpmfg';


const Outer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 8px;
`;

const ColumnZero = function () {
    const [dummyData, setData] = React.useState([]);
    const [endLoading, setEndLoading] = React.useState(false);
    let data = []
    for (let i = 0; i < 3564; i++) {
        data.push({
            previewImg: `https://merryterrachristmas.s3.ap-northeast-2.amazonaws.com/santa_seals/${i}.gif`,

        });
    }
    return (
        <div className='row'>
            {data.map((nft, index) => (
                <div key={index} className="d-item col-lg-4 col-md-6 col-sm-6 col-xs-12">
                    <div className="nft__item">
                        <div className="nft__item_wrap">
                            <Outer>
                                <span>
                                    <img src={nft.previewImg} className="lazy nft__item_preview" alt="" />
                                </span>
                            </Outer>
                        </div>
                        
                    </div>
                </div>
            ))}
        </div>
    );
}

export default ColumnZero;